import { CheckoutSession, PaymentStatus, SubscriptionStatusResponse, BillingInterval, CoursePackageName } from "@nicsmith/shared_types";
import { baseApi } from "./api";

interface CreateCheckoutArgs {
  course_id: number;
  package_name: CoursePackageName;
  success_url: string;
  cancel_url: string;
}

interface CreateSubscriptionCheckoutArgs {
  billing_interval: BillingInterval;
  success_url: string;
  cancel_url: string;
}

export const paymentsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    createCheckoutSession: builder.mutation<CheckoutSession, CreateCheckoutArgs>({
      query: (body) => ({
        url: "/payments/checkout",
        method: "POST",
        body,
      }),
    }),

    getPaymentStatus: builder.query<PaymentStatus, string>({
      query: (sessionId) => `/payments/status/${sessionId}`,
    }),

    createSubscriptionCheckout: builder.mutation<CheckoutSession, CreateSubscriptionCheckoutArgs>({
      query: (body) => ({
        url: "/payments/subscribe",
        method: "POST",
        body,
      }),
    }),

    getSubscriptionStatus: builder.query<SubscriptionStatusResponse, void>({
      query: () => "/payments/subscription",
      providesTags: ["Subscription"],
    }),

    cancelSubscription: builder.mutation<{ message: string }, void>({
      query: () => ({
        url: "/payments/subscription/cancel",
        method: "POST",
      }),
      invalidatesTags: ["Subscription"],
    }),
  }),
});

export const {
  useCreateCheckoutSessionMutation,
  useGetPaymentStatusQuery,
  useCreateSubscriptionCheckoutMutation,
  useGetSubscriptionStatusQuery,
  useCancelSubscriptionMutation,
} = paymentsApi;
